import template from "./sw-code.mjs";
import { render } from "lit-html";
import { HeartBank } from "../../../managers/HeartBank";
import QRCode from "qrcode";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import { HB_VAULT, LANGUAGE } from "../../global";
import Strings from "../../../models/Strings.json";
const strings: any = Strings;

// to used for now
export class SwCode extends HTMLElement {
    private heartbank = new HeartBank();
    private modal: ModalInterface;

    private code: HTMLElement;
    private picture: HTMLPictureElement;
    private img: HTMLImageElement;
    private button: HTMLElement;

    private link = "";

    constructor() {
        super();
        render(template(null), this);

        this.code = this.querySelector("#sw-code")!;
        this.picture = this.querySelector("picture")!;
        this.img = this.querySelector("#sw-code-qr")!;
        this.button = this.querySelector("#sw-code-button")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                this.code.style.zIndex = "70";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-code",
            override: true
        };

        this.modal = new Modal(this.code, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.picture.addEventListener("click", this.copyLink.bind(this));
        this.button.addEventListener("click", this.copyLink.bind(this));
    }

    private async copyLink() {
        await navigator.clipboard.writeText(this.link);
        this.dispatchEvent(
            new CustomEvent<{ info: string }>("sw-banner", {
                bubbles: true,
                detail: {
                    info: strings.code[LANGUAGE]
                }
            })
        );
    }

    //TODO: later distinguish between agent link and profile page; for now just show agent link only
    show(action: string = "") {
        this.link =
            HB_VAULT +
            `/?lang=${strings.language[LANGUAGE]}&origin=${
                this.heartbank.isRunningAsPWA() ? "pwa" : "web"
            }#/carnelian/id/${action}`;

        QRCode.toDataURL(
            this.link,
            {
                width: 1000,
                errorCorrectionLevel: "H",
                type: "image/png",
                margin: 0,
                color: {
                    dark: "#fff",
                    light: "#0000"
                }
            },
            (error: Error | null | undefined, url: string) => {
                if (error) {
                    console.error("Error generating QR Code:", error);
                    this.hide();
                } else {
                    this.img.src = url;
                    this.modal.show();
                }
            }
        );
    }

    hide() {
        this.modal.hide();
    }
}
